(function () {
  const preloader = document.getElementById('mevlana-preloader');
  if (!preloader) return;

  const minDuration = Number(preloader.dataset.minDuration) || 900;
  const navDuration = Number(preloader.dataset.navDuration) || 450;
  const navEnabled = preloader.dataset.navEnabled === 'true';
  const isDesignMode = document.documentElement.classList.contains('shopify-design-mode');
  const isNavTransition = sessionStorage.getItem('mevlanaPreloaderNav') === '1';

  sessionStorage.removeItem('mevlanaPreloaderNav');

  let start = performance.now();
  const targetDuration = isNavTransition ? navDuration : minDuration;

  function setPending(active) {
    document.documentElement.classList.toggle('mevlana-preloader-pending', active);
  }

  function hide(immediate) {
    preloader.classList.add('is-hidden');
    setPending(false);

    const remove = function () {
      preloader.remove();
    };

    if (immediate) {
      remove();
      return;
    }

    window.setTimeout(remove, 350);
  }

  function show() {
    preloader.classList.remove('is-hidden');
    setPending(true);
    start = performance.now();
  }

  function tryHide() {
    const elapsed = performance.now() - start;
    const remaining = Math.max(0, targetDuration - elapsed);
    window.setTimeout(function () {
      hide(false);
    }, remaining);
  }

  if (isDesignMode) {
    hide(true);
    return;
  }

  setPending(true);

  if (document.readyState === 'complete') {
    tryHide();
  } else {
    window.addEventListener('load', tryHide, { once: true });
    window.setTimeout(tryHide, targetDuration + 1200);
  }

  if (navEnabled) {
    document.addEventListener(
      'click',
      function (event) {
        const link = event.target.closest('a[href]');
        if (!link) return;
        if (link.target === '_blank' || link.hasAttribute('download')) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        const href = link.getAttribute('href');
        if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return;
        if (link.closest('[data-no-preloader]')) return;

        let url;
        try {
          url = new URL(link.href, window.location.origin);
        } catch (error) {
          return;
        }

        if (url.origin !== window.location.origin) return;
        if (url.pathname === window.location.pathname && url.search === window.location.search) return;

        sessionStorage.setItem('mevlanaPreloaderNav', '1');
        show();
      },
      true
    );
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      hide(false);
    }
  });
})();
